/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteFileDto } from '../../models/delete-file-dto';

export interface StorageControllerDeleteFile$Params {
  key: string;
}

export function storageControllerDeleteFile(
  http: HttpClient,
  rootUrl: string,
  params: StorageControllerDeleteFile$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DeleteFileDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    storageControllerDeleteFile.PATH,
    'delete',
  );
  if (params) {
    rb.path('key', params.key, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteFileDto>;
      }),
    );
}

storageControllerDeleteFile.PATH = '/storage/s3/key/{key}';
